import {readStorage, writeStorage} from '@/core/local-storage/localStorage';

const THEME_KEY = 'bo:theme';
const LEGACY_THEME_KEY = 'bo_theme';

// One-time cleanup of old key
localStorage.removeItem(LEGACY_THEME_KEY);

export function readTheme(): boolean {
  return readStorage(THEME_KEY) === 'dark';
}

export function writeTheme(isDark: boolean): void {
  writeStorage(THEME_KEY, isDark ? 'dark' : 'light');
}

export function initTheme(): void {
  document.documentElement.classList.toggle('dark', readTheme());
}
